<template>
  <svg
    width="24"
    height="24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  ><g
    clip-path="url(#a)"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  ><path d="M12 .75v7.5M15.75 2.25l-3.75 3-3.75-3M2.257 6.375l6.495 3.75M5.431 3.877l.723 4.748-4.473 1.748M2.257 17.625l6.495-3.75M1.681 13.627l4.473 1.748-.723 4.748M12 23.25v-7.5M8.25 21.75l3.75-3 3.75 3M21.743 17.625l-6.495-3.75M18.57 20.123l-.724-4.748 4.473-1.748M21.743 6.375l-6.495 3.75M22.32 10.373l-4.474-1.748.723-4.748M12 8.25l-3.248 1.875v3.75L12 15.75l3.248-1.875v-3.75L12 8.25Z" /></g><defs><clipPath id="a"><path
    fill="#fff"
    d="M0 0h24v24H0z"
  /></clipPath></defs></svg>
</template>
